"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _entries = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/entries"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _Box = _interopRequireDefault(require("../Box"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _Theme = require("../Theme");

var _ShowHide = _interopRequireDefault(require("../ShowHide"));

var _Grid = _interopRequireDefault(require("../Grid"));

var _index = require("../index");

var __jsx = _react["default"].createElement;
var useLayoutEffect = typeof window === "object" ? _react.useLayoutEffect : _react.useEffect;

var MenuLayoutContext = _react["default"].createContext({});

var MenuBar = function MenuBar(_ref) {
  var open = _ref.open,
      takesSpace = _ref.takesSpace,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["open", "takesSpace"]);
  return __jsx(_Box["default"], props);
};

function MenuBarSticky(_ref2) {
  var _ref2$open = _ref2.open,
      open = _ref2$open === void 0 ? true : _ref2$open,
      props = (0, _objectWithoutProperties2["default"])(_ref2, ["open"]);

  var _useState = (0, _react.useState)("auto"),
      height = _useState[0],
      setHeight = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      sticky = _useState2[0],
      setSticky = _useState2[1];

  var ref = (0, _react.useRef)(null);
  var context = (0, _react.useContext)(MenuLayoutContext);
  var container = document.getElementById("__sticky__");
  (0, _react.useEffect)(function () {
    var onScrollListener = function onScrollListener() {
      var rect = ref.current.getBoundingClientRect();
      var menuBottomY = document.getElementById("__menubottom__").getBoundingClientRect().top;
      var stickyBarY = document.getElementById("__sticky__").getBoundingClientRect().top;
      /**
       * IMPORTANT!
       *
       * There's assymetry here. Depending on open / not open state of bar, we differently pick the moment it becomes sticky. if not opened it becomes sticky "behind the curtains" (when totally covered by menu). If opened, then standard sticky.
       */

      if (!sticky) {
        if (open) {
          // if sticky and open
          if (rect.top < menuBottomY) {
            setHeight(rect.height);
            setSticky(true);
          }
        } else {
          // if sticky but NOT open, let it flow behind menu (like it's normally in body content) and THEN fix.
          if (rect.bottom < menuBottomY) {
            setHeight(rect.height);
            setSticky(true);
          }
        }
      } else {
        if (rect.top >= stickyBarY) {
          setHeight("auto");
          setSticky(false);
        }
      }
    };

    window.addEventListener("scroll", onScrollListener, {
      passive: true
    });
    return function () {
      window.removeEventListener("scroll", onScrollListener);
    };
  }, [sticky, open]);
  (0, _react.useEffect)(function () {
    context.setStickyOpen(open);
  }, [open]);
  var isDisplayedInPortal = sticky && container;
  var state = {
    stuck: isDisplayedInPortal
  };
  var children = typeof props.children === "function" ? props.children(state) : props.children;
  return __jsx(_Box["default"], {
    _ref: ref,
    sx: {
      height: height
    }
  }, isDisplayedInPortal && _reactDom["default"].createPortal(children, container), !isDisplayedInPortal && children);
}

function MenuLayout(props) {
  var _props$offset = props.offset,
      offset = _props$offset === void 0 ? 0 : _props$offset,
      contentAbove = props.contentAbove;
  var children = [];
  var fixedBars = [];

  var _useState3 = (0, _react.useState)(true),
      stickyOpen = _useState3[0],
      _setStickyOpen = _useState3[1];

  _react["default"].Children.forEach(props.children, function (child) {
    if (child && child.type === MenuBar) {
      fixedBars.push(child);
    } else {
      children.push(child);
    }
  });

  fixedBars.push(__jsx(MenuBar, {
    id: "__sticky__",
    open: stickyOpen,
    takesSpace: false
  }));
  return __jsx(MenuLayoutContext.Provider, {
    value: {
      setStickyOpen: function setStickyOpen(open) {
        _setStickyOpen(open);
      }
    }
  }, __jsx(_Box["default"], {
    sx: {
      position: "relative"
    }
  }, __jsx(_Box["default"], {
    sx: {
      position: "relative",
      zIndex: 200
    }
  }, contentAbove), __jsx(_Box["default"], {
    sx: {
      position: "sticky",
      top: 0,
      left: 0,
      width: "100%",
      zIndex: 100
    },
    id: "__menubarsticky__"
  }, __jsx(MenuBarsContainer, {
    bars: fixedBars
  })), __jsx(_Box["default"], {
    sx: {
      pt: offset,
      position: "relative",
      zIndex: 0
    }
  }, children)));
}

MenuLayout.MenuBar = MenuBar;
MenuLayout.MenuBarSticky = MenuBarSticky;
var _default = MenuLayout;
exports["default"] = _default;

var isBarOpen = function isBarOpen(bar) {
  var open = bar.props.open;

  if (typeof open === "undefined") {
    open = true;
  } else {
    open = !!open;
  }

  return open;
};
/**
 * Version with recursion and with ShowHide
 */


var MenuBarsContainer = function MenuBarsContainer(_ref3) {
  var bars = _ref3.bars,
      _ref3$previousBarTake = _ref3.previousBarTakesSpace,
      previousBarTakesSpace = _ref3$previousBarTake === void 0 ? true : _ref3$previousBarTake;
  var theme = (0, _Theme.useTheme)();

  if (!bars || bars.length === 0) {
    return __jsx(_Box["default"], {
      id: "__menubottom__",
      sx: {
        position: "relative"
      }
    }, __jsx(_Box["default"], {
      sx: {
        position: "absolute",
        top: "notificationSystemOffset",
        left: "notificationSystemOffset",
        width: theme.space.notificationSystemWidth,
        display: ["none", null, "block"]
      }
    }, __jsx(_Grid["default"], {
      cols: 1,
      gap: "notificationSystemSeparator",
      id: "__notifications-menu-topLeft__"
    })), __jsx(_Box["default"], {
      sx: {
        position: "absolute",
        top: "notificationSystemOffset",
        right: "notificationSystemOffset",
        width: theme.space.notificationSystemWidth,
        display: ["none", null, "block"]
      }
    }, __jsx(_Grid["default"], {
      cols: 1,
      gap: "notificationSystemSeparator",
      id: "__notifications-menu-topRight__"
    })), __jsx(_Box["default"], {
      sx: {
        position: "absolute",
        top: "notificationSystemOffset",
        right: "notificationSystemOffset",
        left: "notificationSystemOffset",
        display: ["block", null, "none"]
      }
    }, __jsx(_Grid["default"], {
      cols: 1,
      gap: "notificationSystemSeparator",
      id: "__notifications-menu-topMobile__"
    })));
  }

  var bar = bars[0];
  var open = isBarOpen(bar);
  var takesSpace = !!bar.props.takesSpace && previousBarTakesSpace;
  return __jsx(_Box["default"], {
    sx: {
      position: takesSpace ? "relative" : "absolute",
      top: takesSpace ? 0 : "100%",
      width: "100%",
      zIndex: -1
    }
  }, __jsx(_Box["default"], {
    sx: (0, _objectSpread3["default"])({
      position: "relative",
      zIndex: 0,
      width: "100%"
    }, takesSpace ? {} : {
      transform: !open ? "translateY(-100%)" : "none",
      transition: "transform .35s cubic-bezier(0.19, 1, 0.22, 1)"
    }),
    className: "__menubar__"
  }, __jsx(_Box["default"], {
    sx: {
      position: "fixed",
      top: 0,
      left: 0,
      zIndex: -1,
      width: "100%",
      height: "100%",
      // VERY IMPORTANT!!!! Makes entire container overflow: hidden so that flying content doesn't create horizontal scroll.
      pointerEvents: "none",
      // VERY IMPORTANT!!!!
      display: "flex",
      justifyContent: "center",
      opacity: 0
    },
    className: "__menubarshade__"
  }), __jsx(_Box["default"], {
    sx: {
      position: "absolute",
      zIndex: 0,
      width: "100%",
      // height: "100vh", // VERY IMPORTANT!!!! Makes entire container overflow: hidden so that flying content doesn't create horizontal scroll.
      // overflow: "hidden",
      pointerEvents: "none",
      // VERY IMPORTANT!!!!
      display: "flex",
      justifyContent: "center"
    }
  }, __jsx(_Box["default"], {
    sx: {
      width: "100%",
      pointerEvents: "auto"
    },
    className: "__menulayerstop__"
  })), __jsx(_Box["default"], {
    className: "__menubarcontent__",
    sx: {
      width: "100%"
    }
  }, takesSpace && __jsx(_ShowHide["default"], {
    isOpen: open,
    stickToBottom: true
  }, bar), !takesSpace && bar), __jsx(_Box["default"], {
    sx: {
      position: "absolute",
      zIndex: 1,
      width: "100%",
      // height: "100vh", // VERY IMPORTANT!!!! Makes entire container overflow: hidden so that flying content doesn't create horizontal scroll.
      // overflow: "hidden",
      pointerEvents: "none",
      // VERY IMPORTANT!!!!
      display: "flex",
      justifyContent: "center"
    }
  }, __jsx(_Box["default"], {
    sx: {
      pointerEvents: "auto",
      width: "100%"
    },
    className: "__menulayers__"
  })), __jsx(MenuBarsContainer, {
    bars: bars.slice(1),
    previousBarTakesSpace: takesSpace
  })));
};
/**
 * Version with recursion + margin-top
 */
// const MenuBarsContainer = ({ bars, isPreviousOpen = true }) => {
//   if (!bars || bars.length === 0) {
//     return <Box id={"__menubottom__"} />;
//   }
//
//   const bar = bars[0];
//   const open = isBarOpen(bar);
//
//   return (
//     <Box sx={{ position: "relative" }}>
//       <Box
//         sx={{
//           transform: !open ? "translateY(-100%)" : "none",
//           transition: "transform .35s cubic-bezier(0.19, 1, 0.22, 1)"
//         }}
//       >
//         {bar}
//         <Box
//           sx={{
//             position: "absolute",
//             top: "100%",
//             width: "100%",
//             zIndex: -1
//           }}
//         >
//           <MenuBarsContainer bars={bars.slice(1)} />
//         </Box>
//       </Box>
//     </Box>
//   );
// };

/**
 * Version without recursion with margin-top
 */
// const MenuBarsContainer = ({bars}) => {
//     return (
//         <Box sx={{position: "relative"}}>
//             {bars.map((bar, index) => {
//
//                 const open = isBarOpen(bar);
//                 console.log('open', open);
//
//                 return <Box sx={{
//                     position: "relative",
//                     zIndex: 100 - index,
//                 }}>
//                     <Box sx={{
//                         // transform: !open ? "translateY(-100%)" : 0,
//                         marginTop: !open ? "-100%" : 0,
//                         transition: "all .35s cubic-bezier(0.19, 1, 0.22, 1)"
//                     }}>
//                     {bar}
//                     </Box>
//                 </Box>
//             })}
//             <Box id={"__menubottom__"}/>
//         </Box>
//     );
// };

/**
 * Version without recursion and with ShowHide
 */
// const MenuBarsContainer = ({bars}) => {
//     return (
//         <Box sx={{position: "relative"}}>
//             {bars.map((bar, index) => {
//
//                 const open = isBarOpen(bar);
//
//                 return <Box sx={{
//                     position: "relative",
//                       transform: !open ? "translateY(-100%)" : "none",
//                       transition: "transform .35s cubic-bezier(0.19, 1, 0.22, 1)",
//                     zIndex: 100 - index
//
//                 }}>
//                     <ShowHide isOpen={/*open*/true} sx={{zIndex: 100 - index}} stickToBottom={true}>
//                         {bar}
//                     </ShowHide>
//                 </Box>
//             })}
//             <Box id={"__menubottom__"}/>
//         </Box>
//     );
// };

/**
 * Version with recursion + translate only
 */
// const MenuBarsContainer = ({ bars, isPreviousOpen = true }) => {
//   if (!bars || bars.length === 0) {
//     return <Box id={"__menubottom__"} />;
//   }
//
//   const bar = bars[0];
//   const open = isBarOpen(bar);
//
//   return (
//     <Box sx={{ position: "relative" }}>
//       <Box
//         sx={{
//           transform: !open ? "translateY(-100%)" : "none",
//           transition: "transform .35s cubic-bezier(0.19, 1, 0.22, 1)"
//         }}
//       >
//         {bar}
//         <Box
//           sx={{
//             position: "absolute",
//             top: "100%",
//             width: "100%",
//             zIndex: -1
//           }}
//         >
//           <MenuBarsContainer bars={bars.slice(1)} />
//         </Box>
//       </Box>
//     </Box>
//   );
//
//   /**
//    * Below prototype is responsible for being able to hide 2 bars at the same time without harmonica effect.
//    *
//    * This has couple of problems:
//    * 1. Sometimes it's not animated (because of jumping from absolute to relative animation doest fire
//    * 2. If C is animating under B and then suddenly B becomes hidden too how do we do it without jank?
//    * 3. Also what happens during resizing of bars?
//    *
//    *
//    */
//   // const open = isBarOpen(bar);
//   // const nextBarOpen = bars.length > 1 && isBarOpen(bars[1]);
//   //
//   // return <Box sx={{position: "relative"}}>
//   //     <Box sx={{transform: !open && isPreviousOpen ? "translateY(-100%)" : "none", transition: "transform .35s cubic-bezier(0.19, 1, 0.22, 1)"}}>
//   //         { bar }
//   //         <Box sx={{
//   //             position: !open && !nextBarOpen ? "relative" : "absolute",
//   //             top: !open && !nextBarOpen ? 0 : "100%",
//   //             width: "100%",
//   //             zIndex: -1}}>
//   //             <MenuBarsContainer bars={bars.slice(1)} isPreviousOpen={open} />
//   //         </Box>
//   //     </Box>
//   // </Box>
// };
//
// function useLayer(props) {
//     let {
//         open,
//         anchoredTo = "window",
//         animationTime = 1000,
//         openOnHover = true,
//         onMount,
//         onMount2
//     } = props;
//
//     const [anchorRect, setAnchorRect] = useState(null);
//     const [isDisplayed, setDisplayed] = useState(false);
//     const [internalOpen, setInternalOpen] = useState(false);
//
//     const buttonRef = useRef(null);
//
//     // TODO: make it possible to steer Layer from hook AND from button. For now, with Layer+button we have only "uncontrolled state". Most frequently used!
//     if (button) {
//         button = React.cloneElement(button, {
//             onClick: () => {
//                 if (openOnHover) {
//                     setInternalOpen(true);
//                 } else {
//                     setInternalOpen(!internalOpen);
//                 }
//             },
//             onMouseEnter: () => {
//                 if (!openOnHover) {
//                     return;
//                 }
//
//                 setInternalOpen(true);
//             },
//             onMouseOut: () => {
//                 if (!openOnHover) {
//                     return;
//                 }
//
//                 setInternalOpen(false);
//             },
//             _ref: buttonRef
//         });
//
//         anchoredTo = buttonRef;
//
//         const [debouncedOpen] = useDebounce(internalOpen, 100);
//         open = debouncedOpen;
//     }
//
//     const ref = useRef(null);
//     const timeout = useRef(null);
//
//     useLayoutEffect(
//         () => {
//             clearTimeout(timeout.current);
//
//             if (open) {
//                 if (onMount) { onMount(ref.current.getBoundingClientRect())}
//
//                 window.getComputedStyle(ref.current).opacity; // recalculate styles
//
//                 if (onMount2) { onMount(ref.current.getBoundingClientRect())}
//
//                 setDisplayed(true);
//
//             } else {
//                 timeout.current = setTimeout(() => {
//                     setDisplayed(false);
//                 }, animationTime);
//             }
//         },
//         [open]
//     );
//
// }

/**
 * For now only uncontrolled (button + layer)
 */


var defaultBackgroundOverlay = {
  color: "black",
  opacity: 0.5,
  animationTime: 0.3,
  animationEase: "linear"
};

function useDialogs(_ref4) {
  var items = _ref4.items,
      _ref4$openOnHover = _ref4.openOnHover,
      openOnHover = _ref4$openOnHover === void 0 ? true : _ref4$openOnHover,
      _ref4$backgroundStyle = _ref4.backgroundStyles,
      backgroundStyles = _ref4$backgroundStyle === void 0 ? function (_ref5) {
    var isVisible = _ref5.isVisible;
    return {
      opacity: isVisible ? 1 : 0
    };
  } : _ref4$backgroundStyle,
      _ref4$animationTimeou = _ref4.animationTimeout,
      animationTimeout = _ref4$animationTimeou === void 0 ? 0 : _ref4$animationTimeou,
      onChange = _ref4.onChange,
      _ref4$positionedRelat = _ref4.positionedRelativeToTop,
      positionedRelativeToTop = _ref4$positionedRelat === void 0 ? false : _ref4$positionedRelat,
      _ref4$backgroundOverl = _ref4.backgroundOverlay,
      backgroundOverlay = _ref4$backgroundOverl === void 0 ? null : _ref4$backgroundOverl;
  var layers = items; // let buttons = [];
  // let buttonRefs = useRef(layers.map(_ => React.createRef()));

  var _useState4 = (0, _react.useState)(false),
      mounted = _useState4[0],
      setMounted = _useState4[1];

  var initState = {};
  layers.forEach(function (layer, index) {
    initState[(layer.key || index).toString()] = {
      active: false,
      visible: false,
      buttonRef: _react["default"].createRef(),
      layer: layer
    };
  });
  var anchorRects = (0, _react.useRef)({}); // we cache anchor rects for now, not to call getBoundingClientRect every render

  var containerRef = (0, _react.useRef)(null);
  var backgroundRef = (0, _react.useRef)(null);

  var _useState5 = (0, _react.useState)(initState),
      state = _useState5[0],
      setState = _useState5[1];

  var _useState6 = (0, _react.useState)(false),
      isSwitchingState = _useState6[0],
      setSwitchingState = _useState6[1];

  var timer = (0, _react.useRef)(null);
  var buttons = [];
  var contents = [];
  var hideTimers = (0, _react.useRef)({});
  var isAtInitState = !(0, _values["default"])(state).reduce(function (acc, val) {
    return acc || val.visible;
  }, false); // init state means that all layers are fully closed (not closing).

  var isAnyActive = (0, _values["default"])(state).reduce(function (acc, val) {
    return acc || val.active;
  }, false); // init state means that all layers are fully closed (not closing).

  var activeKey = null;
  (0, _entries["default"])(state).forEach(function (_ref6) {
    var _ref7 = (0, _slicedToArray2["default"])(_ref6, 2),
        key = _ref7[0],
        val = _ref7[1];

    if (val.active) {
      activeKey = key;
    }
  });
  var cachedNodes = (0, _react.useRef)(null);

  if (mounted && !cachedNodes.current) {
    var menuBar = (0, _values["default"])(state)[0].buttonRef.current.closest(".__menubar__");
    cachedNodes.current = {
      content: menuBar.querySelector(".__menubarcontent__"),
      portal: menuBar.querySelector(positionedRelativeToTop ? ".__menulayerstop__" : ".__menulayers__"),
      // TODO: could be done better
      shade: menuBar.querySelector(".__menubarshade__")
    };
  }

  var getPosition = function getPosition(key) {
    if (key === null) {
      return;
    }

    var _state$key$layer = state[key].layer,
        _state$key$layer$offs = _state$key$layer.offsetX,
        offsetX = _state$key$layer$offs === void 0 ? 0 : _state$key$layer$offs,
        _state$key$layer$offs2 = _state$key$layer.offsetY,
        offsetY = _state$key$layer$offs2 === void 0 ? 0 : _state$key$layer$offs2,
        width = _state$key$layer.width,
        anchoredTo = _state$key$layer.anchoredTo,
        _state$key$layer$posX = _state$key$layer.posX,
        posX = _state$key$layer$posX === void 0 ? "left" : _state$key$layer$posX;

    if (!anchorRects.current[key]) {
      anchorRects.current[key] = state[key].buttonRef.current.getBoundingClientRect();
    }

    var anchorRect = anchorRects.current[key];
    var position = {};

    if (anchoredTo === "window") {
      switch (posX) {
        case "center":
          position.center = true;
          break;

        case "left":
          position.left = offsetX;
          position.right = "auto";
          break;

        case "right":
          position.left = "auto";
          position.right = offsetX;
          break;
      }
    } else {
      switch (posX) {
        case "center": // todo: center

        case "right":
          position.left = "auto";
          position.right = offsetX + (window.innerWidth - anchorRect.right);
          break;

        case "left-outside":
          position.left = "auto";
          position.right = offsetX + (window.innerWidth - anchorRect.left);
          break;

        case "right-outside":
          position.left = offsetX + anchorRect.right;
          position.right = "auto";
          break;

        case "left":
          position.left = offsetX + anchorRect.left;
          position.right = "auto";
      }
    }

    position.top = offsetY;
    position.width = width;
    position.anchoredTo = anchoredTo;
    return position;
  }; // 0 -> at init state
  // 1 -> invisible
  // 2 -> visible


  var applyBackgroundStyles = function applyBackgroundStyles(_ref8) {
    var isVisible = _ref8.isVisible,
        width = _ref8.width,
        height = _ref8.height,
        _ref8$noTransition = _ref8.noTransition,
        noTransition = _ref8$noTransition === void 0 ? false : _ref8$noTransition;
    var bs = backgroundStyles({
      isVisible: isVisible
    }); // Defaults

    backgroundRef.current.style.width = "100%";
    backgroundRef.current.style.height = "100%";
    backgroundRef.current.style.transition = "all .35s cubic-bezier(0.19, 1, 0.22, 1)";

    for (var x in bs) {
      backgroundRef.current.style[x] = bs[x];
    }

    if (width) {
      backgroundRef.current.style.width = width;
    }

    if (height) {
      backgroundRef.current.style.height = height;
    }

    if (noTransition) {
      backgroundRef.current.style.transition = "none";
    }
  };

  var switchLayer = function switchLayer(key) {
    if (key === activeKey) {
      return;
    }

    if (isAtInitState) {
      // if coming from empty, we set init state for animation
      // applyBackgroundStyles({
      //   isVisible: false,
      //   noTransition: true
      // });
      // backgroundRef.current.style.width = "100%";
      // backgroundRef.current.style.height = "100%";
      //
      // const bs = backgroundStyles({ isVisible: true });
      // for (let x in bs) {
      //     backgroundRef.current.style[x] = bs[x];
      // }
      //
      // backgroundRef.current.style.transition = "none";
      var pos = getPosition(key); // containerRef.current.style.left = `${pos.left}px`;
      // containerRef.current.style.right = `${pos.right}px`;
      // containerRef.current.style.top = `${pos.top}px`;
      // containerRef.current.style.transition = "none";
    } else {} // const backgroundRect = backgroundRef.current.getBoundingClientRect();
      // applyBackgroundStyles({
      //             //     transition: "none",
      //             //     isVisible: true,
      //             //     width: backgroundRect.width + "px",
      //             //     height: backgroundRect.height + "px"
      //             // });
      // backgroundRef.current.style.width = backgroundRect.width + "px";
      // backgroundRef.current.style.height = backgroundRect.height + "px";
      // backgroundRef.current.style.transition = "none";

      /**
       * relative means that this menu TAKES SPACE (position: relative)
       */


    setState(function (prevState) {
      var newState = (0, _objectSpread3["default"])({}, prevState);

      for (var k in newState) {
        if (k === key) {
          clearTimeout(hideTimers.current[k]);
          newState[k].active = true;
          newState[k].visible = true; // visible might be not active (when hiding animation in progress).
        } else {
          if (k === activeKey && activeKey !== null) {
            // timeout for previous key
            hideTimers.current[activeKey] = setTimeout(function () {
              var count = 0;

              for (var _k in state) {
                if (state[_k].visible) {
                  count++;
                }
              }

              setState(function (currentState) {
                var newState = (0, _objectSpread3["default"])({}, currentState, (0, _defineProperty2["default"])({}, activeKey, (0, _objectSpread3["default"])({}, currentState[activeKey], {
                  visible: false
                })));
                return newState;
              });
            }, animationTimeout);
          }

          newState[k].active = false;
        }
      }

      return newState;
    });
    setSwitchingState(true);

    if (onChange) {
      onChange({
        oldKey: activeKey,
        newKey: key
      });
    }
  };

  useLayoutEffect(function () {
    if (!isSwitchingState) {
      return;
    }

    var _ = window.getComputedStyle(backgroundRef.current).height; // force recalculate styles

    if (isAnyActive) {
      // backgroundRef.current.style.width = "100%";
      // backgroundRef.current.style.height = "100%";
      // backgroundRef.current.style.opacity = 1;
      // backgroundRef.current.style.transition =
      //     "all .35s cubic-bezier(0.19, 1, 0.22, 1)";
      var containerRect = containerRef.current.getBoundingClientRect(); // applyBackgroundStyles({
      //   isVisible: true,
      //   width: containerRect.width + "px", //"100%",
      //   height: containerRect.height + "px" //"100%"
      // });

      var pos = getPosition(activeKey); // containerRef.current.style.left = `${pos.left}px`;
      // containerRef.current.style.right = `${pos.right}px`;
      // containerRef.current.style.top = `${pos.top}px`;
      //
      // // containerRef.current.style.left = `${50 * index}px`;
      // containerRef.current.style.transition =
      //   "all .35s cubic-bezier(0.19, 1, 0.22, 1)";

      if (backgroundOverlay) {
        var config = (0, _assign["default"])(defaultBackgroundOverlay, backgroundOverlay);
        cachedNodes.current.shade.style.transition = "opacity ".concat(config.animationTime, "s ").concat(config.animationEase);
        cachedNodes.current.shade.style.backgroundColor = "black";
        cachedNodes.current.shade.style.opacity = config.opacity;
      }
    } else {
      // backgroundRef.current.style.width = "100%";
      // backgroundRef.current.style.height = 0;
      // backgroundRef.current.style.opacity = 0;
      // backgroundRef.current.style.transition =
      //     "all .35s cubic-bezier(0.19, 1, 0.22, 1)";
      // backgroundRef.current.style.width = "100%";
      // backgroundRef.current.style.height = "100%";
      // backgroundRef.current.style.transition = "all 2s linear";// cubic-bezier(0.19, 1, 0.22, 1)";
      // applyBackgroundStyles({
      //   isVisible: false
      // });
      cachedNodes.current.shade.style.opacity = 0; // const bs = backgroundStyles({ isVisible: false });
      // for (let x in bs) {
      //     backgroundRef.current.style[x] = bs[x];
      // }
      //
      //
      // timer.current = setTimeout(() => {
      //   // all relative flags must go down to false (which means that isAtInitState will light up).
      //
      //   let newState = {
      //     ...state
      //   };
      //
      //   for (let k in newState) {
      //     newState[k].relative = false;
      //   }
      //
      //   setState(newState);
      // }, 350);
    }

    setSwitchingState(false); // setContent(
    //     content.map(item =>
    //         item.active
    //             ? { ...item, isVisible: true }
    //             : { ...item, isVisible: false }
    //     )
    // );
    // setStatus(0);
  }, [isSwitchingState]);
  var hoverTimer = (0, _react.useRef)(null);

  var onHover = function onHover(key) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
    clearTimeout(hoverTimer.current);

    if (timeout <= 0) {
      switchLayer(key);
    } else {
      hoverTimer.current = setTimeout(function () {
        switchLayer(key);
      }, timeout);
    }
  }; // on menu hover!!!


  (0, _react.useEffect)(function () {
    if (!mounted) {
      return;
    }

    if (!positionedRelativeToTop) {
      return;
    }

    var onMouseOver = function onMouseOver() {// onHover(activeKey);
    };

    var onMouseOut = function onMouseOut() {// onHover(null);
    };

    cachedNodes.current.content.addEventListener("mouseover", onMouseOver);
    cachedNodes.current.content.addEventListener("mouseout", onMouseOut);
    return function () {
      cachedNodes.current.content.removeEventListener("mouseover", onMouseOver);
      cachedNodes.current.content.removeEventListener("mouseover", onMouseOut);
    };
  }, [mounted, activeKey]); // on route change!

  (0, _react.useEffect)(function () {
    var onRouteChange = function onRouteChange() {
      onHover(null, 0);
    };

    if (!window.__cui_onRouteChange) {
      window.__cui_onRouteChange = [];
    }

    window.__cui_onRouteChange.push(onRouteChange);

    return function () {
      window.__cui_onRouteChange = window.__cui_onRouteChange.filter(function (x) {
        return x !== onRouteChange;
      });
    };
  }, [activeKey]);
  layers.forEach(function (layer, index) {
    var key = (layer.key || index).toString();
    var isActive = state[key].active;
    var visible = state[key].visible;

    var button = _react["default"].cloneElement(layer.button, {
      onClick: function onClick() {
        if (openOnHover) {
          onHover(key, 0);
        } else {
          onHover(activeKey === key ? null : key, 0);
        }
      },
      onMouseEnter: function onMouseEnter() {
        if (!openOnHover) {
          return;
        }

        onHover(key, 100);
      },
      onMouseLeave: function onMouseLeave() {
        if (!openOnHover) {
          return;
        }

        onHover(null, 100);
      },
      _ref: state[key].buttonRef,
      selected: isActive,
      key: "button-" + key
    });

    if (mounted) {
      var content = typeof layer.content === "function" ? layer.content({
        isVisible: isActive && !isSwitchingState
      }) : layer.content;
      var pos = getPosition(key) || {};
      contents.push(__jsx(_Box["default"], {
        sx: {
          position: "absolute",
          // isActive || (activeKey === null && visible)
          //   ? "relative"
          //   : "absolute",
          top: pos.top,
          left: pos.left,
          right: pos.right,
          width: pos.width,
          // left: 0,
          zIndex: isActive ? 1 : 0,
          pointerEvents: isActive ? "auto" : "none",
          opacity: visible ? 1 : 0 // left: position.left,
          // right: position.right,
          // top: offsetY,
          // width: "max-content"
          // width: "max-content",
          // width: "100%"
          // width

        },
        onMouseEnter: function onMouseEnter() {
          if (!openOnHover) {
            return;
          }

          onHover(key);
        },
        onMouseLeave: function onMouseLeave() {
          if (!openOnHover) {
            return;
          }

          onHover(null);
        },
        key: "portal-" + key
      }, content));
    }

    buttons.push(button);
  });
  (0, _react.useEffect)(function () {
    setMounted(true);
  }, []);

  var portal = mounted && _reactDom["default"].createPortal(__jsx(_Box["default"], {
    sx: {
      position: "absolute",
      top: 0,
      left: 0,
      pointerEvents: isAnyActive ? "auto" : "none",
      width: "100%"
    },
    key: "portal",
    _ref: containerRef
  }, __jsx(_Box["default"], {
    sx: {
      position: "absolute",
      top: 0,
      left: 0,
      transformOrigin: "0 0",
      zIndex: -1,
      width: "100%" // bg: "white",
      // boxShadow: "0 0px 14px rgba(0, 0, 0, 0.15)"

    },
    _ref: backgroundRef
  }), contents), cachedNodes.current.portal);

  buttons[0] = _react["default"].cloneElement(buttons[0], {
    __portals__: portal
  });
  return {
    buttons: buttons,
    hide: function hide() {
      switchLayer(null);
    },
    isOpen: isAnyActive
  };
}

function Dialog(props) {
  var button = props.button,
      children = props.children,
      openOnHover = props.openOnHover,
      backgroundStyles = props.backgroundStyles,
      animationTimeout = props.animationTimeout,
      hideOnLinkClick = props.hideOnLinkClick,
      positionedRelativeToTop = props.positionedRelativeToTop,
      onChange = props.onChange;

  var _useDialogs = useDialogs({
    items: [(0, _objectSpread3["default"])({
      button: button,
      content: children
    }, props)],
    openOnHover: openOnHover,
    backgroundStyles: backgroundStyles,
    animationTimeout: animationTimeout,
    positionedRelativeToTop: positionedRelativeToTop,
    onChange: onChange
  }),
      buttons = _useDialogs.buttons,
      layers = _useDialogs.layers;

  return buttons[0];
}

MenuLayout.Dialog = Dialog;
MenuLayout.useDialogs = useDialogs;